import React from 'react';
import {
  Link
} from "react-router-dom";

 

export default class BodyNow extends React.Component{
	constructor(props){
        super(props);
        this.state = {
            body_now : [
				{
					cart:"mypham",
					class:"table1_img_mypham",
					table:"table1",
					text:"MIX"
				},
				{
					cart:"thoitrang",
					class:"table2_img_thoitrang",
					table:"table2",
					text:"MATCH"
				}
			]
    	}
    }

    bodyNow=(datas)=>{
    	var result = null;
    		result = datas.map((data, index)=>{
	    		return(
	    			<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 custom_col" key={index}>
						<div className={data.table}>
							<Link to={data.cart}>
	                            <div className={data.class}>
	                                <div className="overlow"></div>
	                                <h3>{data.text}</h3>
	                            </div>
	                        </Link>
							
						</div>
					</div>
	    		)
	    	})
	    return result;
    }


    render(){
    	const {body_now} = this.state;
    	return( 
    		<div className="body_now">
    			<div className="row custom_row">
					{this.bodyNow(body_now)}
				</div>
    		</div>
    	)
    }
};

